import { z } from 'zod';
import { useTranslation } from 'react-i18next';
import {
  getDefaultValueByQuestionId,
  saveEddQuestionToLocalStore,
} from '@Pages/happyFlowPages/eddQuestions/shared.utils';
import { EDD_VERSION } from '@Pages/happyFlowPages/eddQuestions/consts';
import { usePostEddData } from '@Pages/happyFlowPages/eddQuestions/hooks/usePostEddData';
import { useBoundStore } from '@Store/useBoundStore';
import { useFormHook } from '@Hooks/index';
import { useNavigationManager } from '@Router/useNavigationManager';
import { RoutesMap } from '@Router/router.types';
import { EddEmbeddedFields } from '../../../embedded/fields.types';

export const useLogic = () => {
  const { mutateAsync: postEddData, isPending: isPostingEddData } = usePostEddData();
  const { getEddEmbeddedQuestions } = useBoundStore((state) => state);
  const { navigateToNextPage } = useNavigationManager();
  const { t } = useTranslation('eddQuestions');

  const formMethods = useFormHook({
    schemaTitle: 'internationalActivity',
    formSchema: z.object({
      [EddEmbeddedFields.EDD_EMBEDDED_INTERNATIONAL_ACTIVITY]: z
        .array(z.string().min(1))
        .min(1, 'Please select an option')
        .refine((value) => (value.includes('OTHER') ? false : true)),
    }),
    formDefaultValues: {
      [EddEmbeddedFields.EDD_EMBEDDED_INTERNATIONAL_ACTIVITY]: (() => {
        const value = getDefaultValueByQuestionId(
          EddEmbeddedFields.EDD_EMBEDDED_INTERNATIONAL_ACTIVITY
        );
        if (!Array.isArray(value)) return [];
        return value.filter((item: string) => item);
      })(),
    },
  });

  const reactiveInternationalActivityList = formMethods.watch(
    EddEmbeddedFields.EDD_EMBEDDED_INTERNATIONAL_ACTIVITY
  );

  const handleSubmit = async () => {
    /** Save to local store */
    saveEddQuestionToLocalStore({
      question: t('organic.internationalActivity.question'),
      questionId: EddEmbeddedFields.EDD_EMBEDDED_INTERNATIONAL_ACTIVITY,
      answer: JSON.stringify(
        formMethods.getValues(EddEmbeddedFields.EDD_EMBEDDED_INTERNATIONAL_ACTIVITY)
      ),
    });

    /** Save to Server */
    try {
      await postEddData({
        version: EDD_VERSION,
        results: getEddEmbeddedQuestions(),
      });
      navigateToNextPage(RoutesMap.EDD_INTERNATIONAL_ACTIVITY);
    } catch (error) {
      /** TODO: Handle error - Check with PM */
      console.error(error);
    }
  };

  return {
    formMethods,
    handleSubmit,
    reactiveInternationalActivityList,
    isPostingEddData,
  };
};
